import { Box, Image, Text, useWindowDimensions } from '@jfs/ui-new'
import { staticStrings } from '../../static/staticStrings'
import usePadding from '../../util/usePadding'
import { isMobileWidth } from '../../util/util'
import { AnimatedIcon } from './AnimatedIcon'

export const ShopAnywhere = ({
  setBasketHeight,
  setBasketOffset,
  moveOutAnimation,
  moveInAnimation,
  basketHeight,
}: any) => {
  const resPadding = usePadding()
  const viewportWidth = useWindowDimensions()
  const isMob = isMobileWidth(viewportWidth)
  return (
    <Box pt={108} ph={2 * resPadding}>
      <Box ph={isMob ? undefined : 48}>
        <Text
          title={staticStrings.shopAnywhere}
          fontFamily={'jiotype-black'}
          fontSize={isMob ? 24 : 64}
          lineHeight={isMob ? 36 : 80}
          letterSpacing={isMob ? 0 : -2.5}
          textAlign={'center'}
        />
      </Box>
      <Box
        align="center"
        justify="center"
        mt={isMob ? 56 : 0}
        pt={isMob ? 48 : 250}
        onLayout={(evt: any) => [
          setBasketOffset(evt?.nativeEvent?.layout?.top),
          setBasketHeight(evt?.nativeEvent?.layout?.height),
        ]}>
        <Image
          source={require('../../assets/svg/shopAnywhere/basket.svg')}
          width={'90vw'}
          height={isMob ? 171 : 170}
          resizeMode={'center'}
        />
        <Box position={'absolute'} top={isMob ? '72%' : '93%'}>
          <Image
            source={require('../../assets/svg/shopAnywhere/basket-handle-thread.svg')}
            width={isMob ? 148 : 330}
            height={isMob ? 86 : 92}
            resizeMode={'center'}
          />
        </Box>
        <AnimatedIcon
          source={require('../../assets/svg/shopAnywhere/img1.svg')}
          width={isMob ? 18 : 38}
          height={isMob ? 26 : 52}
          top={isMob ? 90 : 260}
          left={isMob ? -32 : 100}
          moveOutAnimation={moveOutAnimation}
          moveInAnimation={moveInAnimation}
          basketHeight={basketHeight}
        />
        <AnimatedIcon
          source={require('../../assets/svg/shopAnywhere/img2.svg')}
          width={isMob ? 38 : 88}
          height={isMob ? 38 : 81}
          top={isMob ? 24 : 144}
          left={isMob ? -10 : 186}
          moveInAnimation={moveInAnimation}
          moveOutAnimation={moveOutAnimation}
          basketHeight={basketHeight}
        />
        <AnimatedIcon
          source={require('../../assets/images/shopanywhere/hamleys.png')}
          width={isMob ? 40 : 84}
          height={isMob ? 40 : 82}
          top={isMob ? 30 : 156}
          left={isMob ? 10 : 220}
          moveOutAnimation={moveOutAnimation}
          moveInAnimation={moveInAnimation}
          basketHeight={basketHeight}
        />
        <AnimatedIcon
          source={require('../../assets/images/shopanywhere/jiomart.png')}
          width={isMob ? 38 : 84}
          height={isMob ? 38 : 82}
          top={isMob ? -10 : 90}
          left={isMob ? 48 : 312}
          moveOutAnimation={moveOutAnimation}
          moveInAnimation={moveInAnimation}
          basketHeight={basketHeight}
        />
        <AnimatedIcon
          source={require('../../assets/images/shopanywhere/ajio.png')}
          width={isMob ? 38 : 84}
          height={isMob ? 38 : 82}
          top={isMob ? 58 : 210}
          left={isMob ? 42 : 320}
          moveOutAnimation={moveOutAnimation}
          moveInAnimation={moveInAnimation}
          basketHeight={basketHeight}
        />
        <AnimatedIcon
          source={require('../../assets/images/shopanywhere/urban-ladder.png')}
          width={isMob ? 46 : 98}
          height={isMob ? 46 : 98}
          top={isMob ? 24 : 150}
          left={isMob ? 82 : 402}
          moveOutAnimation={moveOutAnimation}
          moveInAnimation={moveInAnimation}
          basketHeight={basketHeight}
        />
        <AnimatedIcon
          source={require('../../assets/images/shopanywhere/ril-digital.png')}
          width={isMob ? 38 : 82}
          height={isMob ? 38 : 82}
          top={isMob ? -16 : 40}
          left={isMob ? 118 : 422}
          moveOutAnimation={moveOutAnimation}
          moveInAnimation={moveInAnimation}
          basketHeight={basketHeight}
        />

        <AnimatedIcon
          source={require('../../assets/svg/shopAnywhere/img3.svg')}
          width={isMob ? 12 : 24}
          height={isMob ? 12 : 24}
          top={isMob ? 0 : 64}
          left={isMob ? 24 : 224}
          moveOutAnimation={moveOutAnimation}
          moveInAnimation={moveInAnimation}
          basketHeight={basketHeight}
        />
        <AnimatedIcon
          source={require('../../assets/svg/shopAnywhere/img4.svg')}
          width={isMob ? 36 : 88}
          height={isMob ? 36 : 81}
          top={isMob ? 60 : 212}
          left={isMob ? 180 : 520}
          moveOutAnimation={moveOutAnimation}
          moveInAnimation={moveInAnimation}
          basketHeight={basketHeight}
        />
        <AnimatedIcon
          source={require('../../assets/images/shopanywhere/jio.png')}
          width={isMob ? 12 : 84}
          height={isMob ? 12 : 82}
          top={isMob ? 36 : 214}
          left={isMob ? 46 : 500}
          moveOutAnimation={moveOutAnimation}
          moveInAnimation={moveInAnimation}
          basketHeight={basketHeight}
        />
        <AnimatedIcon
          source={require('../../assets/images/shopanywhere/milk-basket.png')}
          width={isMob ? 38 : 98}
          height={isMob ? 38 : 98}
          top={isMob ? 6 : 120}
          left={isMob ? 146 : 520}
          moveOutAnimation={moveOutAnimation}
          moveInAnimation={moveInAnimation}
          basketHeight={basketHeight}
        />
        <AnimatedIcon
          source={require('../../assets/images/shopanywhere/zivame.png')}
          width={isMob ? 38 : 98}
          height={isMob ? 38 : 98}
          top={isMob ? 10 : 120}
          left={isMob ? 180 : 640}
          moveOutAnimation={moveOutAnimation}
          moveInAnimation={moveInAnimation}
          basketHeight={basketHeight}
        />
        <AnimatedIcon
          source={require('../../assets/svg/shopAnywhere/img5.svg')}
          width={isMob ? 12 : 81}
          height={isMob ? 12 : 18}
          top={isMob ? 60 : 230}
          left={isMob ? 210 : 550}
          moveOutAnimation={moveOutAnimation}
          moveInAnimation={moveInAnimation}
          basketHeight={basketHeight}
        />
        <AnimatedIcon
          source={require('../../assets/svg/shopAnywhere/img6.svg')}
          width={isMob ? 12 : 24}
          height={isMob ? 12 : 24}
          top={isMob ? -8 : 80}
          left={isMob ? 240 : 620}
          moveOutAnimation={moveOutAnimation}
          moveInAnimation={moveInAnimation}
          basketHeight={basketHeight}
        />
        <AnimatedIcon
          source={require('../../assets/svg/shopAnywhere/img7.svg')}
          width={isMob ? 36 : 38}
          height={isMob ? 36 : 52}
          top={isMob ? 36 : 180}
          left={isMob ? '98%' : 780}
          moveOutAnimation={moveOutAnimation}
          moveInAnimation={moveInAnimation}
          basketHeight={basketHeight}
        />
      </Box>
    </Box>
  )
}
